import { useMemo } from "react";
import { format } from "date-fns";
import { Download, Eye, Mail, Pencil } from "lucide-react";

import { DataTable } from "components/ui/DataTable";

export const LettersTable = ({
  letters,
  currentLetterId,
  isReadOnly = false,
  onEdit,
  onDownload,
  onSendEmail,
}) => {
  const columns = useMemo(
    () => [
      {
        id: "name",
        header: "Title",
        render: (letter) => letter.name || "Untitled",
      },
      {
        id: "createdBy",
        header: "Created By",
        render: (letter) => {
          const first = letter.staffMember?.firstName || "";
          const last = letter.staffMember?.lastName || "";
          return [first, last].filter(Boolean).join(" ") || "-";
        },
      },
      {
        id: "createdDate",
        header: "Created Date",
        render: (letter) =>
          letter.documentCreated
            ? format(new Date(letter.documentCreated), "dd-MM-yyyy")
            : "-",
      },
    ],
    []
  );

  const rowActions = useMemo(() => {
    const actions = [
      {
        label: isReadOnly ? "View letter" : "Edit letter",
        icon: isReadOnly ? Eye : Pencil,
        onClick: onEdit,
        primary: true,
        disabled: (row) => row.id === currentLetterId,
      },
      {
        label: "Download",
        icon: Download,
        onClick: onDownload,
        primary: true,
      },
    ];

    if (!isReadOnly && onSendEmail) {
      actions.push({
        label: "Send Email",
        icon: Mail,
        onClick: onSendEmail,
        primary: true,
        disabled: (row) => !row.documentId,
      });
    }

    return actions;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onEdit, onDownload, onSendEmail, isReadOnly, currentLetterId]);

  return (
    <div>
      <DataTable
        columns={columns}
        data={letters}
        getRowId={(row) => row.id}
        rowActions={rowActions}
        rowActionsLabel="Letter actions"
        emptyTitle="No letters found"
        emptyText="There are no letters for this consultation."
        getRowClassName={(row) => (row.id === currentLetterId ? "active" : "")}
        rowsPerPage={20}
        rowsOptions={[5, 10, 20, 50, "All"]}
      />
    </div>
  );
};
